import { tokenService } from '../../_services'
import { AuthService } from './auth-service'

const authService = new AuthService(tokenService)

export { authService, tokenService }
